/**
 * @file    TableBody.tsx
 * @scope   VIEW
 * @summary Picks what the widget body shows: line chart → horizontal bar chart → grid.
 * @consumes ReactECharts, HorizontalBarChart, TableGrid
 * @produces JSX only
 * @sideEffects None.
 */
import React from 'react';
import ReactECharts from 'echarts-for-react';
import HorizontalBarChart from 'components/Charts/HorizontalBarChart/HorizontalBar';
import TableGrid from '../TableGrid/TableGrid';
import { TableState } from '../../common/types';

export interface TableBodyProps {
  showLineChart: boolean;
  chartView: boolean;
  echartRef: React.RefObject<any>;
  lineChartOptions: any;
  lineChartHeight: number;
  chartData: any;
  options: any;
  widgetProps: any;
  table?: TableState;
  loading?: boolean;
}

const TableBody: React.FC<TableBodyProps> = ({
  showLineChart,
  chartView,
  echartRef,
  lineChartOptions,
  lineChartHeight,
  chartData,
  options,
  widgetProps,
  table,
  loading,
}) => {
  if (showLineChart) {
    return (
      <ReactECharts
        ref={echartRef}
        opts={{ renderer: 'svg' }}
        option={lineChartOptions}
        style={{ width: '100%', height: lineChartHeight }}
      />
    );
  }
  if (chartView) {
    return (
      <HorizontalBarChart colors={['']} options={options} {...widgetProps} response={chartData} />
    );
  }
  if (table?.columns && Array.isArray(table?.data) && table.data.length > 0) {
    const { striped, showTotals, pagination } = options?.table || {};
    return (
      <TableGrid
        columns={table.columns}
        data={table.data}
        striped={striped}
        showTotals={showTotals}
        pagination={pagination}
        loading={loading}
      />
    );
  }
  return null;
};

export default TableBody;
